import { Component } from '@angular/core';

@Component({
  selector: 'twaice-fe-solution',
  templateUrl: './solution.component.html',
  styleUrls: ['./solution.component.scss'],
  standalone: false,
})
export class SolutionComponent {}
